import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5 },
  viewport: { once: true },
};

const allServices = [
  {
    title: "Social Media Marketing",
    desc: "Gestione professionale Facebook, Instagram e WhatsApp.",
    image: "https://images.unsplash.com/photo-1554177255-61502b352de3?w=600&q=80",
    color: "#FF3366",
    tag: "SOCIAL",
    scrollTo: "#prezzi",
  },
  {
    title: "Advertising",
    desc: "Campagne Google Ads e Facebook Ads mirate.",
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&q=80",
    color: "#3B82F6",
    tag: "ADS",
    scrollTo: "#prezzi",
  },
  {
    title: "SEO & Analytics",
    desc: "Ottimizzazione motori di ricerca e performance.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80",
    color: "#22C55E",
    tag: "SEO",
    scrollTo: "#prezzi",
  },
  {
    title: "Video & Content",
    desc: "Contenuti video professionali e storytelling.",
    image: "https://images.unsplash.com/photo-1625690303837-654c9666d2d0?w=600&q=80",
    color: "#E97A1F",
    tag: "VIDEO",
    scrollTo: "#media-social",
  },
  {
    title: "Reputation Management",
    desc: "Reputazione online su Google e Trustpilot.",
    image: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=600",
    color: "#A855F7",
    tag: "REPUTATION",
    scrollTo: "#prezzi",
  },
  {
    title: "Visibilita TV",
    desc: "Spot su Canale 5, Italia 1 e Rete 4.",
    image: "https://images.unsplash.com/photo-1742805382153-bb4be26d6031?w=600&q=80",
    color: "#EF4444",
    tag: "TV",
    scrollTo: "#media-social",
  },
  {
    title: "Sviluppo App",
    desc: "App iOS e Android, pubblicazione store.",
    image: "https://images.unsplash.com/photo-1502201563651-826cbb30c3dd?w=600&q=80",
    color: "#14B8A6",
    tag: "APP",
    scrollTo: "#app-dev",
  },
  {
    title: "Graphic Design",
    desc: "Creativita visiva per brand e comunicazione.",
    image: "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg?auto=compress&cs=tinysrgb&w=600",
    color: "#F59E0B",
    tag: "DESIGN",
    scrollTo: "#prezzi",
  },
  {
    title: "Innovation Lab",
    desc: "R&D, brevetti e tecnologie automotive.",
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=600&q=80",
    color: "#8B5CF6",
    tag: "R&D",
    scrollTo: "/innovation-lab",
    isPage: true,
  },
  {
    title: "Blockchain",
    desc: "Certificazione filiera e identita digitale.",
    image: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=600&q=80",
    color: "#06B6D4",
    tag: "BLOCKCHAIN",
    scrollTo: "#brevetti",
  },
  {
    title: "Web Design",
    desc: "Siti web moderni, performanti e responsive.",
    image: "https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=600",
    color: "#EC4899",
    tag: "WEB",
    scrollTo: "#prezzi",
  },
  {
    title: "Piattaforme Digitali",
    desc: "Marketplace, SaaS e app personalizzate.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80",
    color: "#10B981",
    tag: "PLATFORM",
    scrollTo: "#piattaforme",
  },
];

function handleScroll(selector) {
  const el = document.querySelector(selector);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

function ServiceCarousel() {
  const doubled = [...allServices, ...allServices];
  return (
    <div className="overflow-hidden">
      <div className="animate-carousel-left" style={{ animationDuration: "60s" }}>
        <div className="flex gap-2.5 sm:gap-3" style={{ width: "max-content" }}>
          {doubled.map((s, i) => (
            <div
              key={i}
              onClick={() => s.isPage ? window.location.href = s.scrollTo : handleScroll(s.scrollTo)}
              className="group relative w-[200px] sm:w-[280px] h-[130px] sm:h-[170px] flex-shrink-0 overflow-hidden cursor-pointer"
            >
              <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10 group-hover:from-black/70 transition-all duration-500" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ boxShadow: `inset 0 0 30px ${s.color}25`, border: `1px solid ${s.color}50` }} />
              <div className="absolute top-2 left-2">
                <span className="text-[7px] sm:text-[8px] font-mono font-bold tracking-[0.25em] px-1.5 py-0.5 backdrop-blur-md" style={{ backgroundColor: `${s.color}30`, color: s.color }}>{s.tag}</span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-2.5 sm:p-3">
                <h4 className="font-heading text-xs sm:text-sm font-bold text-white leading-tight">{s.title}</h4>
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-[2px] opacity-0 group-hover:opacity-100 transition-opacity" style={{ backgroundColor: s.color }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function ServicesSection() {
  return (
    <>
      <section id="servizi" data-testid="services-section" className="py-14 sm:py-20 lg:py-28 bg-[#050505] relative overflow-hidden">
        <div className="absolute top-0 left-1/4 w-72 h-72 bg-[#FF3366]/4 rounded-full blur-[120px] pointer-events-none" />

        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
          <motion.div {...fadeInUp}>
            <span className="font-mono text-[10px] sm:text-xs tracking-[0.3em] text-[#FF3366] uppercase">TUTTI I SERVIZI</span>
            <h2 className="font-heading text-2xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-2 sm:mt-3 leading-[1.1]">
              Tutto cio che facciamo
            </h2>
          </motion.div>
        </div>

        {/* Scrolling carousel */}
        <div className="mt-6 sm:mt-10">
          <ServiceCarousel />
        </div>

        {/* All services grid */}
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10 mt-8 sm:mt-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
            {allServices.map((s, i) => (
              <motion.div
                key={i}
                data-testid={`service-cat-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: i * 0.04 }}
                viewport={{ once: true }}
                onClick={() => s.isPage ? window.location.href = s.scrollTo : handleScroll(s.scrollTo)}
                className="group border border-white/5 bg-white/[0.02] p-3 sm:p-4 cursor-pointer hover:bg-white/[0.04] transition-all duration-300 relative overflow-hidden"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `linear-gradient(135deg, ${s.color}08, transparent)` }} />
                <div className="relative z-10">
                  <span className="inline-block text-[7px] sm:text-[8px] font-mono font-bold tracking-[0.2em] px-1.5 py-0.5 mb-2" style={{ backgroundColor: `${s.color}15`, color: s.color }}>{s.tag}</span>
                  <h3 className="font-heading text-sm sm:text-base font-bold text-white leading-tight">{s.title}</h3>
                  <p className="text-[#C0C0C0] text-[11px] sm:text-xs mt-1.5 font-body leading-relaxed">{s.desc}</p>
                  <ArrowUpRight size={12} className="mt-2 opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: s.color }} />
                </div>
                <div className="absolute bottom-0 left-0 w-0 group-hover:w-full h-[2px] transition-all duration-500" style={{ backgroundColor: s.color }} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Innovation Lab Banner */}
      <section id="innovazione" data-testid="innovation-section" className="py-8 sm:py-14 bg-[#0a0a0a] border-y border-white/5">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12">
          <motion.div {...fadeInUp} className="border border-[#FF3366]/20 bg-[#0d0d0d] p-5 sm:p-8 lg:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-48 h-48 bg-[#FF3366]/5 rounded-full blur-[80px] pointer-events-none" />
            <div className="relative z-10">
              <span className="font-mono text-[10px] sm:text-xs tracking-[0.2em] text-[#FF3366] uppercase">INNOVATION LAB</span>
              <h2 className="font-heading text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight mt-2 text-white">
                Ricerca, Sviluppo & Brevetti
              </h2>
              <p className="text-[#C0C0C0] font-body text-sm mt-2 max-w-md leading-relaxed">
                Materiali innovativi, sistemi intelligenti di bordo, mobilita digitale e gestione del veicolo.
              </p>
            </div>
            <Link to="/innovation-lab" className="flex-shrink-0 bg-[#FF3366] text-white font-bold uppercase tracking-widest px-5 sm:px-7 py-3 text-xs hover:bg-white hover:text-black transition-colors duration-300 flex items-center gap-2 w-full sm:w-auto justify-center">
              SCOPRI IL LAB <ArrowUpRight size={14} />
            </Link>
          </motion.div>
        </div>
      </section>
    </>
  );
}
